import * as React from 'react';
import { BadgeSVGProps } from '../../BadgeImage/BadgeImage.types';

export const Star20mm = ({
	finish
}: BadgeSVGProps) => (
	<svg 
		version="1.1" 
		id="Layer_1" 
		xmlns="http://www.w3.org/2000/svg" 
		xmlnsXlink="http://www.w3.org/1999/xlink" 
		x="0px" 
		y="0px"
		viewBox="0 0 442.5 411.1" 
		enableBackground="new 0 0 442.5 411.1" 
		xmlSpace="preserve"
	>
		<g>
			<radialGradient id="SVGID_1_" cx="221.2573" cy="207.6294" r="206.9314" gradientUnits="userSpaceOnUse">
				<stop  offset="0" style={{ stopColor: "#072653" }} />
				<stop  offset="0.5379" style={{ stopColor: "#072551" }} />
				<stop  offset="0.7317" style={{ stopColor: "#07224A" }} />
				<stop  offset="0.8694" style={{ stopColor: "#061D3F" }} />
				<stop  offset="0.9803" style={{ stopColor: "#05162E" }} />
				<stop  offset="1" style={{ stopColor: "#05142A" }} />
			</radialGradient>
			<path className="background-colour" fill="url(#SVGID_1_)" d="M354.7,399.1c1.7,6-1.2,8.1-6.4,4.8l-117.7-75.1c-5.2-3.3-13.8-3.3-19,0L93.6,403.6
				c-5.2,3.3-8.1,1.2-6.4-4.8l37.6-130.7c1.7-6-0.9-13.9-5.8-17.7l-110.2-85c-4.9-3.8-3.9-7.1,2.3-7.4l141.3-5.9
				c6.2-0.3,13.1-5.2,15.4-11l49.6-127.1c2.3-5.8,5.9-5.8,8.2,0L274.8,141c2.2,5.8,9.2,10.7,15.4,11l141.3,6.3
				c6.2,0.3,7.2,3.6,2.3,7.4l-110.4,84.8c-4.9,3.8-7.6,11.8-5.9,17.7L354.7,399.1z"/>
			<linearGradient id="SVGID_2_" gradientUnits="userSpaceOnUse" x1="2.605684e-07" y1="207.6292" x2="442.5142" y2="207.6292">
				<stop  offset="0" style={{ stopColor: finish.dark }} />
				<stop  offset="0.2462" style={{ stopColor: finish.light }} />
				<stop  offset="0.4444" style={{ stopColor: finish.dark }} />
				<stop  offset="0.695" style={{ stopColor: finish.dark }} />
				<stop  offset="1" style={{ stopColor: finish.light }} />
			</linearGradient>
			<path fill="url(#SVGID_2_)" d="M354.7,399.1l-5.4,1.5c0.2,0.8,0.3,1.3,0.3,1.5l0,0.1l0,0l0,0l0,0l0,0l0,0l1.7,0.2l-1.5-0.7
				c-0.1,0.3-0.1,0.4-0.1,0.5l1.7,0.2l-1.5-0.7l3,1.3l-1.7-2.7c-0.6,0.4-1.1,1-1.3,1.4l3,1.3l-1.7-2.7l1.6,2.5v-3
				c-0.3,0-0.9,0.1-1.6,0.5l1.6,2.5v-3v1.1l0.2-1.1l-0.2,0v1.1l0.2-1.1c0,0-0.1,0-0.4-0.1c-0.2-0.1-0.6-0.3-1-0.6L233.6,324
				c-3.8-2.4-8.2-3.4-12.6-3.4c-4.3,0-8.7,1-12.5,3.4L90.6,398.8c-0.6,0.4-1,0.6-1.2,0.6l-0.2,0.1l0.2,1.1v-1.1l-0.2,0l0.2,1.1v-1.1
				v2.8l1.1-2.5c-0.5-0.2-0.9-0.2-1.1-0.2v2.8l1.1-2.5l-1.4,3.1l2.4-2.5c-0.3-0.3-0.7-0.5-1-0.7l-1.4,3.1l2.4-2.5l-2.1,2.1l2.8-1
				c-0.1-0.3-0.3-0.7-0.8-1.2l-2.1,2.1l2.8-1l-1.4,0.5l1.5-0.2l-0.1-0.3l-1.4,0.5l1.5-0.2l-0.3,0l0.3,0l0,0l-0.3,0l0.3,0l0-0.1
				c0-0.2,0-0.7,0.3-1.5l37.6-130.7c0.5-1.8,0.7-3.7,0.7-5.5c0-3.5-0.8-6.9-2.2-10c-1.4-3.1-3.5-6-6.3-8.2L12.2,161
				c-0.7-0.5-1.1-1-1.1-1.1l0,0l-1.1,0.7l1.2-0.4c-0.1-0.2-0.1-0.3-0.1-0.3l-1.1,0.7l1.2-0.4l-2.8,0.9h2.9c0-0.4-0.1-0.7-0.1-0.9
				l-2.8,0.9h2.9H7.7l3,2c0.4-0.5,0.6-1.3,0.6-2H7.7l3,2l-2.4-1.6l1.7,2.4c0.2-0.1,0.5-0.4,0.7-0.8l-2.4-1.6l1.7,2.4l-0.7-1l0.5,1.2
				l0.2-0.1l-0.7-1l0.5,1.2l0.1,0c0.2-0.1,0.7-0.2,1.5-0.2l141.3-5.9c4.5-0.2,8.7-2,12.2-4.5c3.5-2.5,6.5-5.9,8.2-10.1l49.6-127.1
				c0.2-0.5,0.4-0.8,0.5-1.1c0.1-0.2,0.2-0.3,0.2-0.3l0,0l-0.6-0.5l0.5,0.6l0.1-0.1l-0.6-0.5l0.5,0.6l-1.5-1.8l0.8,2.2
				c0.3-0.1,0.5-0.3,0.6-0.3l-1.5-1.8l0.8,2.2l-1.2-3v3.2c0.4,0,0.9-0.1,1.2-0.2l-1.2-3v3.2v-3.1l-1.4,2.8c0.3,0.2,0.8,0.3,1.4,0.3
				v-3.1l-1.4,2.8l0.9-1.8l-1.3,1.5c0.1,0.1,0.2,0.2,0.4,0.3l0.9-1.8l-1.3,1.5l0.4-0.5l-0.5,0.5l0,0l0.4-0.5l-0.5,0.5l0,0
				c0.1,0.1,0.4,0.5,0.7,1.4l49.3,126.9c1.7,4.2,4.6,7.6,8.2,10.1c3.5,2.5,7.7,4.3,12.2,4.5l141.3,6.3c0.6,0,1.1,0.1,1.3,0.2l0.2,0.1
				l0,0l0.9-2l-1.7,1.3c0.4,0.5,0.8,0.7,0.8,0.7l0.9-2l-1.7,1.3l2.7-2.2l-3.3,1.1c0.1,0.4,0.3,0.7,0.5,1l2.7-2.2l-3.3,1.1l3.3-1.2
				l-3.5,0c0,0.4,0.1,0.8,0.2,1.2l3.3-1.2l-3.5,0h2.8l-2.7-1c-0.1,0.2-0.2,0.5-0.2,1h2.8l-2.7-1l1.1,0.4l-1-0.6l-0.1,0.2l1.1,0.4
				l-1-0.6c0,0-0.1,0.1-0.3,0.3c-0.2,0.2-0.5,0.5-0.9,0.8l-110.4,84.8c-2.9,2.2-4.9,5.1-6.4,8.2c-1.4,3.2-2.2,6.6-2.2,10.1
				c0,1.8,0.2,3.6,0.7,5.4l37.2,130.9L354.7,399.1l5.4-1.5l-37.2-130.9c-0.2-0.7-0.3-1.5-0.3-2.3c0-1.7,0.4-3.7,1.2-5.4
				c0.8-1.7,1.9-3.2,3-4l110.4-84.8c1.4-1.1,2.6-2.2,3.5-3.6c0.5-0.7,0.9-1.5,1.2-2.3c0.3-0.9,0.5-1.9,0.5-3c0-1.5-0.5-3-1.3-4.3
				c-0.6-0.9-1.4-1.6-2.1-2.2c-1.2-0.8-2.4-1.3-3.6-1.6c-1.2-0.3-2.5-0.5-3.8-0.5l-141.3-6.3c-1.7-0.1-4.1-0.9-6.1-2.4
				c-2-1.4-3.6-3.4-4.2-5L230.8,12.1c-0.8-1.9-1.7-3.6-3.1-5.1c-0.7-0.7-1.6-1.4-2.6-2c-1.1-0.5-2.3-0.9-3.6-0.9
				c-1.3,0-2.6,0.3-3.6,0.9c-1.6,0.8-2.7,1.9-3.6,3.1c-0.9,1.2-1.6,2.5-2.1,4l-49.6,127.1c-0.6,1.6-2.2,3.6-4.2,5
				c-2,1.5-4.4,2.3-6.1,2.4l-141.3,5.9c-1.2,0.1-2.3,0.2-3.4,0.4c-1.6,0.4-3.3,1-4.8,2.3c-0.8,0.7-1.5,1.5-1.9,2.6
				c-0.5,1-0.7,2.2-0.7,3.3c0,1.1,0.2,2.1,0.5,2.9c0.5,1.3,1.2,2.4,2,3.3c0.8,0.9,1.7,1.8,2.7,2.6l110.2,85c1.1,0.8,2.2,2.2,2.9,3.9
				c0.8,1.7,1.2,3.7,1.2,5.4c0,0.9-0.1,1.7-0.3,2.4L81.8,397.2l0,0c-0.4,1.6-0.7,3.1-0.7,4.6c0,1,0.1,2,0.4,3c0.2,0.8,0.6,1.6,1,2.3
				c0.7,1.1,1.8,2.2,3.1,2.8c1.3,0.6,2.6,0.9,3.8,0.9c1.4,0,2.7-0.3,3.8-0.7c1.2-0.4,2.3-1,3.4-1.7l117.9-74.8
				c1.4-0.9,3.9-1.6,6.5-1.6c2.6,0,5.1,0.7,6.5,1.6l117.7,75.1c1.1,0.7,2.2,1.3,3.4,1.7c1.2,0.4,2.4,0.7,3.9,0.7
				c1.1,0,2.2-0.2,3.4-0.7c0.9-0.4,1.7-0.9,2.3-1.6c1-1,1.7-2.2,2.1-3.3c0.4-1.2,0.5-2.3,0.5-3.4c0-1.5-0.3-3-0.7-4.6L354.7,399.1z"/>
		</g>
	</svg>
);
